import React, { useState } from "react";
import FormApplication from './components/form';
import {
    Card, Row, Col, Layout, message
} from 'antd';
import moment from 'moment';
import ListAppsAction from './actions/action';

function CreateApp(props) {
    const { Content } = Layout;
    const [listApp, setListApp] = useState({
        application_name: null,
        link_path: null,
        logo: null,
        day_reminder: null,
        email_pic: [],
        email: null,
        order: null
    });

    const handleSaveApp = () => {
        ListAppsAction({type: 'apps/create'}, sessionStorage.getItem('token'), listApp).then((res) => {
          message.info(res.message);
          props.history.push('/apps');
        });
    }

    return (
        <>
        <Content className="content m-0">
          <Row>
            <Col xs={24}>
              <Card className="body-data">
                <FormApplication title="Create Application" listApp={listApp} setApp={setListApp} handleSave={handleSaveApp} />
              </Card>
            </Col>
          </Row>
        </Content>
      </>
    )
}

export default CreateApp;